import { InstructionComponentProps } from "../InstructionComponent"
import ImageTextComponent from "../../ImageTextComponent"
import RegStep1Menu from "../../../resources/tutorial/PROFESSIONAL_REG_1A.png"
import RegStep1Form from "../../../resources/tutorial/PROFESSIONAL_REG_1B.png"

const ArztRegistrationStep1: InstructionComponentProps = {
  name: "Persönliche Daten eingeben",
  path: "/help/arzt/registration-step1",
  description:
    "Bitte klicken Sie auf 'Registrieren' und geben Sie anschließend Ihre persönlichen Daten ein, um Ihr Konto zu erstellen.",
  both: [
    // First ImageTextComponent: “Im Hauptmenü auf Registrieren klicken”
    <ImageTextComponent
      text={
        <>
          <h3 className="font-semibold text-lg">Registrieren auswählen</h3>
          <p>
            1. Klicken Sie im Hauptmenü oben rechts auf <b>Registrieren</b>.
            <br />
          </p>
        </>
      }
      images={[RegStep1Menu]}
      col={true}
    />,
    // Second ImageTextComponent: “Persönliche Daten eingeben”
    <ImageTextComponent
      text={
        <>
          <h3 className="font-semibold text-lg">Persönliche Daten</h3>
          <p>
            2. Geben Sie Ihren <b>Vornamen</b>, <b>Nachnamen</b>,
            <b> Email-Adresse</b> und ein <b>Passwort</b> ein, das die
            Anforderungen erfüllt:
          </p>
          <ul className="list-disc list-inside mt-1">
            <li>8 Zeichen lang</li>
            <li>Mind. 1 Sonderzeichen</li>
            <li>Mind. 1 Großbuchstabe, 1 Kleinbuchstabe, 1 Ziffer</li>
          </ul>
          <p className="mt-2">
            3. Klicken Sie auf <b>Weiter</b>, sobald alle Felder ausgefüllt sind.
          </p>
          <p className="mt-2">
            Falls Sie einen <b>Bestätigungscode</b> per E-Mail bekommen haben,
            geben Sie ihn jetzt ein. Ansonsten können Sie dieses Feld frei
            lassen. 
          </p>
        </>
      }
      images={[RegStep1Form]}
      col={true}
   
    />
  ]
}

export default ArztRegistrationStep1
